<template>
  <div id="chat">
    <div class="DisplayPanel">
      <div
        :class="item[0] + ' information'"
        v-for="(item, key) in data"
        :key="key"
      >
        {{ item[1] }}
      </div>
    </div>
    <input
      class="input"
      placeholder="想聊什么呢？"
      type="text"
      v-model="input"
      @keyup.enter="get"
    />
  </div>
</template>

<script>
	import axios from 'axios'
export default {
  props: ["data1", "data2"],
  name: "intelligence",
  data() {
    return {
      input: "",
      data: this.data1,
    };
  },
  methods: {
    get() {
      if (this.input != "") {
        this.data.push(["user", this.input]);
        let input = this.input;
        this.input = "";
        axios
          .get("http://www.liulongbin.top:3006/api/robot?spoken=" + input)
          .then(
            (i) => {
              this.data.push(["reply", i.data.data.info.text]);
              this.$emit("data1", this.data);
            },
            () => {
              this.data.push(["reply", "抱歉，跨域问题暂未解决"]);
            }
          );
      }else{
        alert("还没有输入哦~");
      }
    },
  },
};
</script>

<style scoped>
.DisplayPanel {
  padding: 20px;
  margin-bottom: 10px;
  height: 300px;
  overflow: auto;
}
.DisplayPanel::-webkit-scrollbar {
  display: none;
}
.input {
  padding-left: 10px;
  width: 100%;
  border: 1px solid gray;
  outline: none;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.8);
}
.reply {
  margin-right: auto;
  background-color: rgba(89, 156, 243, 0.5);
}
.user {
  margin-left: auto;
  background-color: rgba(243, 89, 89, 0.5);
}
.information {
  padding: 5px 10px;
  width: fit-content;
  border: 1px solid gray;
  border-radius: 10px;
  margin-bottom: 10px;
}
</style>